import ApiHelper from "./ApiHelper";
import notify from 'devextreme/ui/notify';
import env from "react-dotenv";

//#
//PROD
const baseURL = process.env.REACT_APP_BASE_URL
const templateURL = process.env.REACT_APP_TEMPLATE_URL
const reportURL = process.env.REACT_APP_REPORT_URL

class GlobalParams {

    static isLogged = false;

    static BaseIP = baseURL;
    static LoginApiUrlPrefixV2 = `${baseURL}/v2-gc-portal/`;
    static ApiUrlPrefix = `${baseURL}/v1-gc-portal/`;
    static LoginApiUrlPrefix = `${baseURL}/`;
    static RptUrlPrefix = reportURL;
    //templates
    static TemplateUrl = `${templateURL}/`;

    static defaultSchemeId = null;

    static membersData = [];
    static IntermediaryId = "";
    static UserEmail = "";
    static ClientId = "";
    static ClientName = "";
    static SchemeId = "";
    static SchemeCreditId = "";
    static MemberNo = "";
    static MemberName = "";
    ///app params////
    static GenderStore = [
        { Code: 'F', Desc: 'FEMALE' },
        { Code: 'M', Desc: 'MALE' },
    ];
    static EndorsementTypes = [
        { id: '2', name: 'Joiners' },
        { id: '3', name: 'Exits' },
        { id: '6', name: 'Salary Change' }
    ];

    static riderOptions = [
        { "id": 2, "description": "Percentage of Sum Assured" },
        { "id": 3, "description": "Multiple of Salary" },
        { "id": 1, "description": "Fixed Benefit" }
    ];

    static ProductPackages = [];
    static Packages = [
        { "id": 1, "description": "Plan 1" },
        { "id": 2, "description": "Plan 2" },
        { "id": 3, "description": "Plan 3" },
        { "id": 4, "description": "Plan 4" }
    ];

    static Currencies = [
        { "id": 1, "description": "Ghana Cedis" },
        { "id": 2, "description": "US Dollar" }
    ];

    static AccountYears = (() => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = 2006; year <= currentYear; year++) {
            years.push({
                id: year.toString(),
                name: year.toString(),
            });
        }
        return years;
    })();

    static AccountMonths = [
        {
            id: '1',
            name: 'January'
        },
        {
            id: '2',
            name: 'February'
        },
        {
            id: '3',
            name: 'March'
        },
        {
            id: '4',
            name: 'April'
        },
        {
            id: '5',
            name: 'May'
        },
        {
            id: '6',
            name: 'June'
        },
        {
            id: '7',
            name: 'July'
        },
        {
            id: '8',
            name: 'August'
        },
        {
            id: '9',
            name: 'September'
        },
        {
            id: '10',
            name: 'October'
        },
        {
            id: '11',
            name: 'November'
        },
        {
            id: '12',
            name: 'December'
        }
    ];
    static DebitsData = [];
    static OccupationClasses = [];
    static IdentityTypes = [];
    static NatureOfBusiness = [];
    static AccessTypes = [];
    static PoliticalStatus = [];
    static ESGStatus = [];
    static UFAADormancyStatus = [];
    static Countries = [];
    static Counties = [];
    static ClaimTpyes = [];
    static ProductClasses = [];
    static ProductRider = [];
    static QuoteProductClasses = [];
    static schemeStore = [];
    static schemeCategoriesStore = [];
    static clientStore = [];
    static StatusesStore = [];
    static AllRiders = [];
    static RelationshipStore = [
        { id: 'FH', name: 'FATHER' },
        { id: 'MT', name: 'MOTHER' },
        { id: 'BR', name: 'BROTHER' },
        { id: 'CH', name: 'CHILD' },
        { id: 'SP', name: 'SPOUSE' },
        { id: 'SS', name: 'SISTER' }
    ];
    static YesNo = [
        { id: '1', description: 'YES' },
        { id: '2', description: 'NO' }
    ]
    static MedicalTypes = [
        { id: '1', name: 'Members Awaiting Medical Examinations' },
        { id: '2', name: 'Members with received medicals' },
        //{ id: '3', name: 'Members Compliance Report' }
    ];
    static PaymentOptions = [
        { id: '1', name: 'Pay Principle Member' },
        { id: '2', name: 'Pay Beneficiary' },
        { id: '3', name: 'Pay Scheme' },
    ];
    static ClaimPaymentMethods = [
        { id: '4', name: 'CHEQUE' },
        { id: '7', name: 'EFT (BANK PAYMENT)' },
        { id: '6', name: 'MOBILE MONEY' }
    ];
    static ClaimCauses = [];
    static ClaimReasons = [
        { id: '25', Description: 'ACCIDENTAL' },
        { id: '26', Description: 'NATURAL' }
    ];

    static ApprovalStore = [
        { id: '1', description: 'APPROVED' },
        { id: '2', description: 'CANCELLED' }
    ];

    static PaymentMethods = [];
    static Banks = [];
    static BankBranches = [];
    static LoanTypes = [];
    static MedicalUwDecision = [];

    static EnquiryStatuses = [
        { Id: '1', Description: 'OPEN' },
        { Id: '2', Description: 'CLOSED' }
    ];

    static MoMoTelcoStore = [
        { id: 'MTNMOB', description: 'MTN MOBILE MONEY' },
        { id: 'TIGOMOB', description: 'TIGO CASH' },
        { id: 'V-CASH', description: 'VODAFONE CASH' }
    ];

    //static bearerToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyNCIsImp0aSI6IjVlOTQwYjQ1YjM5ZmIyN2UzZWM4ZGE4Mzg0YzhmZTI2YjNmMzA3NjgwOWRhOGQ3MDQ0Njc2YjU2YWQ5YmI0MzcyN2FmNmExZmZmZTRiZmQ0IiwiaWF0IjoxNzExNjI5NjMwLjAxMDQ3OSwibmJmIjoxNzExNjI5NjMwLjAxMDQ4NCwiZXhwIjoxNzQzMTY1NjI5LjY4NTA5NCwic3ViIjoiIiwic2NvcGVzIjpbXX0.B7TyTCe5MojAF-vwCmK6IuOLl0H4xJ8qYaH9BMSSt8TTnF8oNSFMaBNm2TkqyJab29n5O4BHUrHhW7AHnSBPY-qc-GAW8lVQT2Pa_0_sgJqQbbhU9rGcSWrgAPhOip4ZygXL1SNP-F75QE6U0Q7k6E6M1Pvzo4u7HjH76Gw23AZ5WWsqyysLsel8aijuD1pt_ndnuuQ2H3NwH-9QHMhCSGo5PsPfisLpri-TGbUt1WKMcwxui8YBSoPVR_63HKqCFRCADbK_L7wiJmjN58BFqwF5F-S1eZwnm6hhSS4OSoGK2m71XAgwuh5uTxlsmf1W0eBvD5HftVdBr2_DrjAJ8lqbP3wHCxZieLCwtZH9oi6GapmC8usGEPkRvxYbCjdxkkhcpeUiawqMb6zFLif7Gt9IMAPkZ3F5Vqu_Rs8zksMWKECEOi1WfoKL7is3H9hV6NLnJeB3ayj1tmCsv4CEAme-mzORnbvazWm1mjPT3dYCOmCT7LnOZljmn3GP8JieHwU-If2j_O2-s6SVaJnCZaGyyk8By9OyDb0cT9ITnczMZZ9nRb4tT183QmVM6RkpU-dvVBsxJLGikvjdGjJo9_MGY3WLUnMuY5A5Q5rcbCD9GzNSZGc_29XCKvfcn3weaYWR8oD6zEYCpmZfxw2zFWkgk3ZAJxQOPvMy_JcEJ6I";
    //static bearerToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMzg4ZjA5YzU1ZDM2ZmZlMjBhOGZjZDNkYmMyZWVhZmU0ZmE3MmMzYTEzZWI3ZGE3YjJiNGZiOTU5YTNlMmYyNDljZWE3ZjI0NjE4M2VlZTYiLCJpYXQiOjE3MDk3MTc3NzAuNzc4MzI5LCJuYmYiOjE3MDk3MTc3NzAuNzc4MzMzLCJleHAiOjE3NDEyNTM3NzAuNzAzMjMsInN1YiI6IiIsInNjb3BlcyI6W119.H_-JgdbLMhtXT5QELCeJRZG79GeaM_EpEU9htYzMbF_QTsRmdiMgNQTyVUJ9ymX6U3dwRZjulNxZ74bsiI_SDxP8SBn6AuMA8v00QYecoz9SnwaxmdvrG1-qtdYA-maFKNmhEmJD3G4tALx1hz6-3lvWMXrM9n8sn_P7bwK7d7wu-30-6kuvLhvYViKjpry_IZjh5ot2Zttgme3e92NBdYgKe6LWG0qNEuWWfiK-_SXl3I4JXgargpxaDB-pSAIfiy_gQFsOQnP-TZeI7yilIKLHgkXnqME7YAUIm8OyjcPEMjOUpFlZhFZVXkKa6IoJv4YFE1DvT_25VyA4UT3fjG6dbtXm2PFQFEP6-fkB20xhdzRoNFKL6RKzCYadCzY3F-Bxm5uGWBF2W3AAAmyN84Sw-vFFOuJzfyrvWMElsep2zsXtZ4eZ4NV2eAb4hdqoIlZEAUBXpLDzl4VCWiW3YW-Kyr00-pC-iGhxGfeRfsC5qtv1vg6Bd477HAR6-BiF9g4-wNSahJw5pzJ5IJ6shm0xIXlNX4GZuhtotM4cy7PxNDUyx8wM3MTDW61L7LtcgyISg25E7X1UEF2GNGIeFwLoX_r7Snga16BSbecuITAaOhiX7i0x1hcgJYfbKoAhempueluiuBJzX8EZS-adpIJvLzy5PKeYm1BGnNqdOFU";

    static bearerToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5OWIxYmVhZi0xZmI4LTQwNzctYjUzMy0wNjk5MjQ3Mjg1MmIiLCJqdGkiOiIyNzU3ZjgzMzI1NWFiY2FkODE2ZDYyZjU0MTczNzhhZDllYThjMzgxNTQyNzZlNGNmOWI2MWFkYjBkZGNjOGEwZDQ0YzIxZmY1NDY5ZTM0ZiIsImlhdCI6MTczMTU5NDQ3Ny43MDA1MDIsIm5iZiI6MTczMTU5NDQ3Ny43MDA1MDQsImV4cCI6MTc2MzEzMDQ3Ny42ODgzMjgsInN1YiI6IiIsInNjb3BlcyI6W119.BzKFH4wsjh6YXvvOJzQB0t-eJXMYK444B2mFws82Pfbg44ogVlI3vdVlYx7T5_FkG39lVQVYX1ElLsv8WNOcEGQKia5w7j-dJpQCTXj-5EY8Ueuej7sRm7T6xb4vTjaDfzCEVHyqRtGZmiR6EzAndt1f03uK2O6jv_oThymI2Nk5hY_7oHTaB8XfbTiXCEDdTN_kZzFIQu9KrPUTGrGyYUuErPamvZhTwQyZAGRXdM1lGTiuB_mckfOOWZFJJPUa0nPj0j3pmszEPQIDSYkHQTQR0bi1V3vhcgKus12jlQqJ7hGB4XSY2x-LCsCPhkwfU08A9BI4OqCsAoSFzfXys1EWXBxk3hkLGN_GBQHsK5CfPQnYKA5kb2e1KjZwc57NvgZm2_O0VbYI1MqqMG9t9j4EgCLH47zkqbbFy1AsG_eGMYQoBpFI17jdHT_naAM9_sH7JL4aYWzI9bUv39wwfv5gr5HtY4LZSsZNDFGDYKhuuqFUO49LiJqRo01AulUm5h-vd54VL4-I2J6VqgaJkauZq-yFh2G6Wy02q7yA-qcfMjWrKAUKUSf4OULJjQ5mdHTz-hi81jOUJNYNcnFgTtTGQWC_WFQPqQpUhokElSbwENBmCbLlWpxJ_UJBzQamrPQN2rhl5rPOaf0dmOkY8i7SqctwUcf8qNKWk-mBGis";
    //static bearerToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxNSIsImp0aSI6IjkyZmVkMzExNmRhZGEyMjk0Y2ZmMDRhM2FlZDc0NDBhODdiZmZjYzJlZTU1ZDY5ZTYzMDExY2QzYzdmNGZjM2IyZDQ2MDdiNmVkNTNhZjI0IiwiaWF0IjoxNzIzMjA5NjkzLjAwMDA1NCwibmJmIjoxNzIzMjA5NjkzLjAwMDA1OCwiZXhwIjoxNzU0NzQ1NjkyLjc0NjA5MSwic3ViIjoiIiwic2NvcGVzIjpbXX0.Hvq-xTDx7UJJIghzO2uKtZwQiKx_IKuDQtO0Q6Gf3UhHqmXb_SdY2F0U7FBcob5NfP0-EnyN4_pfRJ3FeSU6x5ci8MF_f61ICKGCxApbaJv4ayl5qsPg--fvQ3aPq6CwgEy2L7Ff2wfWx8mJMK1r5N_NT7dWbowi91mZovzxbK84KtborUOFaZBzx1HovTcOZJy9m015yzPSY5oOYxN3OzMb1xdTcFQYJ-dIXwdKskIhlFZHgkhyUSrBumOQ340OtucqfdS2Wt5VLQ3DxPBIpnfDUHSotCWpCVT17Dh6uY8jwI86w3xpTlBuI2RXn3Qu_Pg8lTXaT4yubSFffqnsShC1gaYmmMjukFLHo7_Uo4JxXHPGcL6JEaey5y2WAct6G9XQzO9TFuUVnAoRQMrbaKxRhYl2ovO6bW9YOTOChpg-OJ7OeHH3lIC7dCP89LH5YJQfymEjbZ6tNdG4WANXPVbtH2fpMa2cOlCG4uJ5Ugw5VB0VfzabLuzfIHHGyv06TQFxxncas38Pb2KXgQEe55lLPWrV_iHzsch4MA74-JbuhXRuEoWCcldk9udkHAf1nu56CTtVf0DGEwD70aIUPhPlcfMog-q3aD5fNSoPg9l_CJEy6LhqO246KxjLlINnDZ7aw1ALBuQQqjccFyzOnH6rYuWO4sP4Ojgw0RQ-pF0";
    ///endpoints////
    static AllClientsEP = "getGroupClients?";
    static ClientMembersEP = "getMembersPerScheme?";
    static ClientSchemesEP = "getClientSchemes?";
    static SchemeClaimsEP = "all-claims-on-scheme?";
    static DebitNotesSchemeRptEP = "get-report?";

    static ContactPersonId = null;
    static IsClientLoggedIn = false;
    static PopFundAccessLevelId = null;

    static EnquiriesSubjects = [];

    static EnquiriesStore = [];


    static async fetchParams({
        param, property
    }) {
        try {
            const result = await ApiHelper.fetchData(this.ApiUrlPrefix + param, this.bearerToken);
            this[property] = result.data;
        } catch (error) {
            // Handle error, e.g., show an error message
        }
    }

    static formatNumberWithCommas(value) {
        // Convert value to a string with two decimal places
        const formattedValue = Number(value).toFixed(2);

        // Split the value into integer and decimal parts
        const [integerPart, decimalPart] = formattedValue.split('.');

        // Add commas to the integer part
        const numberWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        // Combine the integer part with the decimal part
        return numberWithCommas + '.' + decimalPart;
    }

    static notification(msg) {
        notify(msg, 'success', 10000);
    }

    static removeDuplicatesByPolicyNo(arr) {
        // Create a map to track the highest schemeID for each policy_no
        const policyMap = new Map();
    
        arr.forEach(item => {
            const policyNo = item.policy_no;
            const schemeID = parseInt(item.schemeID, 10);
    
            if (!policyMap.has(policyNo) || schemeID > parseInt(policyMap.get(policyNo).schemeID, 10)) {
                policyMap.set(policyNo, item);
            }
        });
    
        return Array.from(policyMap.values());
    }

    static formatDate(dateString) {
        const date = new Date(dateString);
        if (isNaN(date)) return "Invalid Date";
    
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
    
        return `${day}/${month}/${year}`;
    }


};

export default GlobalParams;